/** Runs diagnostic-only observation without allowing it to affect the observed application flow. */
export const safelyObserveDiagnostics = (observe: () => void): void => {
  try {
    observe();
  } catch {
    // Diagnostics are passive. Malformed or unavailable context must never escape into app logic.
  }
};
